import { render } from "./PageCrumbHeaderSkeleton.vue?vue&type=template&id=46c3d396&scoped=true"
import script from "./PageCrumbHeaderSkeleton.vue?vue&type=script&lang=js"
export * from "./PageCrumbHeaderSkeleton.vue?vue&type=script&lang=js"

import "./PageCrumbHeaderSkeleton.vue?vue&type=style&index=0&id=46c3d396&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-46c3d396"

export default script